$(document).ready(function () {
  const productVariantElement = document.querySelector("product-variants");
  let PreselectedVariantId = $("product-variants").attr("preselected_id");
  (PreselectedVariantId = parseInt(PreselectedVariantId)),
    console.log(PreselectedVariantId),
    PreselectedVariantId &&
      productVariantElement.selectVariant(PreselectedVariantId);
});
function openCity(evt, cityName) {
  var i, tabcontent, tablinks;
  for (
    tabcontent = document.getElementsByClassName("tabcontent"), i = 0;
    i < tabcontent.length;
    i++
  )
    tabcontent[i].style.display = "none";
  for (
    tablinks = document.getElementsByClassName("tablinks"), i = 0;
    i < tablinks.length;
    i++
  )
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  (document.getElementById(cityName).style.display = "block"),
    (evt.currentTarget.className += " active");
}
$(document).ready(function () {
  $(".customer_main").slick({
    slidesToShow: 3,
    dots: !0,
    arrows: !0,
    responsive: [
      { breakpoint: 991, settings: { slidesToShow: 2 } },
      { breakpoint: 799, settings: { slidesToShow: 1 } },
    ],
  });
}),
  $(document).ready(function () {
    $(document).on("click", ".tried-tested-video .video-control", function () {
      var clickedControl = $(this),
        clickedVideo = clickedControl.closest(".popup-video").find("video")[0],
        videoHtml = clickedControl.closest(".video-item").html();
      $(".tested-main-popup").html(videoHtml),
        $(".popup-video video")
          .not(clickedVideo)
          .each(function () {
            this.pause(),
              $(this).siblings(".video-control").removeClass("btnhide");
          });
      var mainPopupVideo = $(".tested-main-popup video")[0];
      mainPopupVideo.paused
        ? (mainPopupVideo.play(),
          $(".tested-main-popup .video-control").addClass("btnhide"))
        : (mainPopupVideo.pause(),
          $(".tested-main-popup .video-control").removeClass("btnhide")),
        $(".tested-main-popup").addClass("video-active"),
        $("body").addClass("video-popup-active");
    }),
      $(document).on("click", ".tested-main-popup .icon-close", function () {
        var mainPopupVideo = $(".tested-main-popup video")[0];
        mainPopupVideo &&
          (mainPopupVideo.pause(),
          $(".tested-main-popup .video-control").removeClass("btnhide")),
          $("body").removeClass("video-popup-active"),
          $(".tested-main-popup").removeClass("video-active"),
          $(".tested-main-popup").empty();
      }),
      $(document).on("click", ".tested-main-popup .icon-volume", function () {
        console.log("this = ", this);
        var mainPopupVideo = $(this)
          .parents(".tested-main-popup")
          .find("video")[0];
        console.log("mainPopupVideo", mainPopupVideo),
          mainPopupVideo &&
            ((mainPopupVideo.muted = !mainPopupVideo.muted),
            $(this).toggleClass("volume-muted", mainPopupVideo.muted));
      });
  }),
  $(document).ready(function () {
    function isInViewport(theDiv) {
      let elementTop = theDiv.offset().top,
        elementBottom = elementTop + theDiv.outerHeight(),
        viewportTop = $(window).scrollTop(),
        viewportBottom = viewportTop + window.innerHeight;
      return elementBottom > viewportTop && elementTop < viewportBottom;
    }
    var animationDone = !1;
    $("#product-block-tested").length &&
      $(window).on("scroll", function () {
        animationDone ||
          (isInViewport($("#product-block-tested")) &&
            ((animationDone = !0),
            $(".circleBarProgress").each(function () {
              var t = $(this).find(".circleBar"),
                x = $(this).find(".circleBarWrapper"),
                i = $(this).find("span"),
                e2 = parseInt(i.text(), 10);
              $({ p: 0 }).animate(
                { p: e2 },
                {
                  duration: 3e3,
                  easing: "swing",
                  step: function (e3) {
                    x.css({
                      background:
                        "conic-gradient(#890000 0deg " +
                        e3 +
                        "%, #FEEAE8 " +
                        e3 +
                        "%)",
                    }),
                      i.text(0 | e3);
                  },
                }
              );
            })));
      });
  }),
  $(".custom-gallery-instafeed").slick({
    slidesToShow: 6,
    dots: !1,
    arrows: !1,
    centerMode: !1,
    responsive: [
      { breakpoint: 998, settings: { slidesToShow: 4, slidesToScroll: 1 } },
      {
        breakpoint: 789,
        settings: { slidesToShow: 3, slidesToScroll: 1, centerMode: !1 },
      },
      {
        breakpoint: 543,
        settings: { slidesToShow: 3, slidesToScroll: 1, centerMode: !1 },
      },
    ],
  }),
  $(".custom-instafeed-slider").slick({
    arrows: !1,
    dots: !1,
    slidesToShow: 6,
    centerMode: !0,
    centerPadding: "100px",
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 4, centerPadding: "50px" },
      },
      { breakpoint: 769, settings: { slidesToShow: 3, centerPadding: "0px" } },
      { breakpoint: 480, settings: { slidesToShow: 2, centerPadding: "30px" } },
    ],
  }),
  $(document).on("click", ".collection-menu-item", function () {
    $(this).addClass("link-active"),
      $(this).siblings().removeClass("link-active");
    var dataTab = $(this).data("tab");
    $(
      ".custom-collection-template .custom-collection-tab .product-item"
    ).hide(),
      $(
        ".custom-collection-template .custom-collection-tab .product-item." +
          dataTab
      ).show();
    var activeText = $(this).text();
    console.log(activeText), $(".collection-title").text(activeText);
  }),
  $(document).on("click", ".grid_list_item .item_list", function () {
    $(this).addClass("active"),
      $(this).siblings().removeClass("active"),
      $(".product-list__inner").addClass("product_list_view");
  }),
  $(document).on("click", ".grid_list_item .item_grid", function () {
    $(this).addClass("active"),
      $(this).siblings().removeClass("active"),
      $(".product-list__inner").removeClass("product_list_view");
  });
var $slider = $(".product-slider-section .slider-product-wrapper"),
  $progressBar = $(".progress__bar, .progress__bar_item"),
  $progressBarLabel = $(".slider__label");
$progressBar.css("background-size", "2% 100%").attr("aria-valuenow", 2),
  $slider.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
    var calc = (nextSlide / (slick.slideCount - 1)) * 100;
    calc === 0
      ? $progressBar.css("background-size", "2% 100%").attr("aria-valuenow", 2)
      : $progressBar
          .css("background-size", calc + "% 100%")
          .attr("aria-valuenow", calc),
      $progressBarLabel.text(calc + "% completed");
  }),
  $slider.slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: !0,
    speed: 400,
    appendArrows: ".slider-nav",
    infinite: !0,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      {
        breakpoint: 789,
        settings: { slidesToShow: 2, adaptiveHeight: !1, slidesToScroll: 1 },
      },
    ],
  }),
  $(document).ready(function () {
    $(".product_custmer_review .review_main").slick({
      infinite: !0,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        { breakpoint: 767, settings: { slidesToShow: 2, slidesToScroll: 1 } },
        { breakpoint: 575, settings: { slidesToShow: 1, slidesToScroll: 1 } },
      ],
    }),
      $(document).ready(function () {
        $(".alternate-image-wrapper").slick({
          slidesToShow: 1,
          dots: !0,
          arrows: !1,
        });
      }),
      $(".products_related .solution-products").slick({
        dots: !1,
        infinite: !1,
        arrows: !0,
        speed: 500,
        slidesToShow: 3.3,
        slidesToScroll: 3,
        responsive: [
          {
            breakpoint: 1024,
            settings: { slidesToShow: 3.3, slidesToScroll: 1, infinite: !0 },
          },
          {
            breakpoint: 799,
            settings: { slidesToShow: 2, slidesToScroll: 1, infinite: !0 },
          },
          {
            breakpoint: 600,
            settings: { slidesToShow: 1, slidesToScroll: 1, infinite: !0 },
          },
          {
            breakpoint: 480,
            settings: { slidesToShow: 1, slidesToScroll: 1, infinite: !0 },
          },
        ],
      }),
      $(".faq-question").click(function () {
        $(this)
          .siblings()
          .slideToggle()
          .parents(".product-faq-item")
          .toggleClass("active"),
          $(this)
            .parents(".product-faq-item")
            .siblings()
            .removeClass("active")
            .find(".faq-answer")
            .slideUp();
      }),
      $(".ques-heading").click(function (j) {
        var dropDown = $(this)
          .closest(".questions__item_row")
          .find(".ques-desc");
        $(this)
          .closest(".question-body")
          .find(".ques-desc")
          .not(dropDown)
          .slideUp(),
          $(this).hasClass("qs_active")
            ? $(this).removeClass("qs_active")
            : ($(".ques-heading.qs_active").removeClass("qs_active"),
              $(this).addClass("qs_active")),
          dropDown.stop(!1, !0).slideToggle(),
          j.preventDefault();
      }),
      $(".collapsible__btn").click(function () {
        $(".collapsible__text_inside").slideToggle(350);
      });
  }),
  $(document).ready(function () {
    $(".product-icon-volume").click(function () {
      var activeVideo = $(".video-active video")[0];
      activeVideo &&
        ((activeVideo.muted = !activeVideo.muted),
        $(this).toggleClass("volume-muted", activeVideo.muted));
    });
    function playPause(videoId, buttonId) {
      var myVideo = document.getElementById(videoId),
        $button = $("#" + buttonId);
      $("video")
        .not(myVideo)
        .each(function () {
          this.pause();
          var otherButtonId = $(this).siblings(".video-control").attr("id");
          $("#" + otherButtonId).removeClass("btnhide"),
            $("#" + otherButtonId)
              .parents(".popup-video")
              .removeClass("video-active"),
            $("#" + otherButtonId)
              .parents("body")
              .removeClass("video-popup-active");
        }),
        myVideo.paused ? myVideo.play() : myVideo.pause(),
        $button.toggleClass("btnhide"),
        $button.parents(".popup-video").addClass("video-active"),
        $button.parents("body").addClass("video-popup-active");
    }
    function videoClose() {
      var activeVideo = $(".video-active video")[0];
      if (activeVideo) {
        activeVideo.pause();
        var activeButtonId = $(activeVideo)
          .siblings(".video-control")
          .attr("id");
        $("#" + activeButtonId).removeClass("btnhide");
      }
      $("body").removeClass("video-popup-active"),
        $(".popup-video").removeClass("video-active");
    }
    $(document).on("click", ".real-review-item .video-control", function () {
      var clickedControl = $(this),
        clickedVideo = clickedControl.closest(".popup-video").find("video")[0],
        videoHtml = clickedControl.closest(".video-item").html();
      $(".review-main-popup").html(videoHtml),
        $(".popup-video video")
          .not(clickedVideo)
          .each(function () {
            this.pause(),
              $(this).siblings(".video-control").removeClass("btnhide");
          });
      var mainPopupVideo = $(".review-main-popup video")[0];
      mainPopupVideo.paused
        ? (mainPopupVideo.play(),
          $(".review-main-popup .video-control").addClass("btnhide"))
        : (mainPopupVideo.pause(),
          $(".review-main-popup .video-control").removeClass("btnhide")),
        $(".review-main-popup").addClass("video-active"),
        $("body").addClass("video-popup-active");
    }),
      $(document).on("click", ".review-main-popup .icon-close", function () {
        var mainPopupVideo = $(".review-main-popup video")[0];
        mainPopupVideo &&
          (mainPopupVideo.pause(),
          $(".review-main-popup .video-control").removeClass("btnhide")),
          $("body").removeClass("video-popup-active"),
          $(".review-main-popup").removeClass("video-active"),
          $(".review-main-popup").empty();
      }),
      $(document).on("click", ".review-main-popup .icon-volume", function () {
        console.log("this = ", this);
        var mainPopupVideo = $(this)
          .parents(".review-main-popup")
          .find("video")[0];
        console.log("mainPopupVideo", mainPopupVideo),
          mainPopupVideo &&
            ((mainPopupVideo.muted = !mainPopupVideo.muted),
            $(this).toggleClass("volume-muted", mainPopupVideo.muted));
      }),
      $(document).on("click", ".review-tab-item", function () {
        $(this).addClass("active"), $(this).siblings().removeClass("active");
        var dataTab = $(this).data("href");
        $(dataTab).addClass("active"),
          $(dataTab).siblings().removeClass("active");
      }),
      $(".main-video-inner").slick({
        infinite: !0,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: !1,
        responsive: [
          { breakpoint: 741, settings: { slidesToShow: 2, slidesToScroll: 1 } },
        ],
      }),
      $(".trust_review_slider").slick({
        infinite: !0,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: !0,
        responsive: [
          {
            breakpoint: 1200,
            settings: { slidesToShow: 2, slidesToScroll: 1 },
          },
          { breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        ],
      });
  }),
  $(document).on(
    "click",
    ".line-item__remove-button.main-product--true",
    function (e2) {
      e2.preventDefault();
      var updates = {};
      (updates[$(this).data("line-id")] = 0),
        $(".product-item-meta__property input.freegiftId").each(function (
          index,
          data
        ) {
          var isLastElement = index == data.length - 1;
          let vId = $(this).val();
          updates[$(this).val()] = 0;
        }),
        fetch(window.Shopify.routes.root + "cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates }),
        })
          .then((response2) => {
            if (isCart()) location.reload();
            else
              return (
                document.documentElement.dispatchEvent(
                  new CustomEvent("cart:refresh", { bubbles: !0 })
                ),
                response2.json()
              );
          })
          .catch((error) => {
            console.error("Error:", error);
          });
    }
  ),
  $(".scroll-to-bundle--js").click(function (e2) {
    e2.preventDefault(),
      $("html,body").animate(
        { scrollTop: $(".product_bundle_wrapper").offset().top - 160 },
        "slow"
      );
  }),
  $(".scroll-to-product-form--js").click(function (e2) {
    e2.preventDefault(),
      $("html,body").animate(
        { scrollTop: $(".product__info").offset().top - 160 },
        "slow"
      );
  }),
  $(".bundle-atc-custom").click(function (e2) {
    e2.preventDefault();
    var $this2 = $(this);
    $this2.addClass("button--loading"),
      $this2.find("span.loader-button__text").hide(),
      $this2.find("span.loader-button__loader").css("display", "contents"),
      $.ajax({
        type: "POST",
        url: "/cart/clear.js",
        data: "",
        dataType: "json",
        success: function () {
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", { bubbles: !0 })
          ),
            $this2.next(".bundle-atc-custom--main").click(),
            setTimeout(function () {
              $this2.removeClass("button--loading"),
                $this2.find("span.loader-button__text").show(),
                $this2.find("span.loader-button__loader").hide();
            }, 1e3);
        },
        error: function (XMLHttpRequest2, textStatus) {},
      });
  });
function isElementInViewport(el) {
  var rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}
$(window).scroll(function () {
  $(this).scrollTop() > 500
    ? $(".custom-product-sticky-form").removeAttr("hidden")
    : $(".custom-product-sticky-form").attr("hidden", !0);
}),
  $(window).scroll(function () {
    if ($(".product_bundle_section").length) {
      var viewportTopBundle = $(window).scrollTop(),
        viewportBottomBundle = viewportTopBundle + $(window).height(),
        elementTopBundle = $(".product_bundle_section").offset().top,
        elementBottomBundle =
          elementTopBundle + $(".product_bundle_section").outerHeight();
      elementBottomBundle >= viewportTopBundle &&
        elementTopBundle <= viewportBottomBundle &&
        $(".custom-product-sticky-form").attr("hidden", !0);
    }
  }),
  $(document).ready(function () {
    var lastScrollTop = 0;
    if (
      ($(window).scroll(function () {
        var currentScrollTop = $(this).scrollTop();
        currentScrollTop < lastScrollTop
          ? $(".scroll-top").addClass("scroll-top--active")
          : $(".scroll-top").removeClass("scroll-top--active"),
          (lastScrollTop = currentScrollTop);
      }),
      $("#stock-number").length)
    ) {
      let updateStockNumber2 = function () {
        let stockNumber = document.getElementById("stock-number"),
          currentNumber = parseInt(stockNumber.innerText),
          decreaseAmount = Math.floor(Math.random() * 5) + 1,
          newNumber = currentNumber - decreaseAmount;
        newNumber > 0
          ? (stockNumber.innerText = newNumber)
          : parseInt(stockNumber.getAttribute("data-order"));
      };
      var updateStockNumber = updateStockNumber2;
      setTimeout(updateStockNumber2, Math.floor(Math.random() * 2001) + 2e3),
        setInterval(() => {
          setTimeout(
            updateStockNumber2,
            Math.floor(Math.random() * 3001) + 2e3
          );
        }, 5e3);
    }
  }),
  $(document).ready(function () {
    $(".mobile-item-title").on("click", function () {
      $(this).parents(".mobile-nav__item_new").addClass("menu-active"),
        $(this)
          .parents(".mobile-nav__item_new")
          .siblings()
          .removeClass("menu-active");
    }),
      $(".drawer__close-button").on("click", function () {
        $(".mobile-nav__item_new").removeClass("menu-active");
      }),
      $(".mobile-item-title-v3").click(function () {
        $(this).siblings(".menu-item-content-v3").slideToggle(),
          $(this).find(".has_sub_icon svg").toggle();
      }),
      $(".tab_heading_item").click(function () {
        $(this).addClass("active"), $(this).siblings().removeClass("active");
        var menuTarget = $(this).data("tab");
        $(this)
          .parents(".mobile_menu_tab")
          .find(".nav_tab_content #" + menuTarget)
          .addClass("active"),
          $(this)
            .parents(".mobile_menu_tab")
            .find(".nav_tab_content #" + menuTarget)
            .siblings()
            .removeClass("active");
      }),
      $(document).on("click", ".click_gift", function () {
        var $this2 = $(this);
        shippingInsuranceAddRemoveCall($this2),
          console.log("function call==================");
      });
  });

$(".custom_variaent_select").change(function () {
  var variantImg = $(this).find("option:selected").data("variantimg"),
    variantDesc = $(this).find("option:selected").data("variantdesc"),
    variantValue = $(this).find("option:selected").data("variantvalue"),
    selectVariantId = $(this).find("option:selected").data("selectvariantid"),
    mainImgId = $(this).find("option:selected").data("mainimgid"),
    mainFirstImg = $(this).find("option:selected").data("mainfirstimg"),
    mainSecondImg = $(this).find("option:selected").data("mainsecondimg"),
    mainMediaId = $(this).find("option:selected").data("mediaid");
  setTimeout(function () {
    console.log(
      "clicked version=====================",
      $(".comboBox_button").find(".select__selected-value").length
    ),
      $(".comboBox_button")
        .find(".select__selected-value")
        .html(
          `<span class="img-wrap"><img src="${variantImg}" alt=""></span><span class="text"><span class="name">${variantValue}</span> <span class="desc">${variantDesc}</span></span>`
        );
  }, 0),
    $(".product__thumbnail-item.is-variantImg").removeClass("active"),
    $(this)
      .parents(".product")
      .find(
        '.product__thumbnail-item[data-variantitem="' + selectVariantId + '"]'
      )
      .prop("aria-current", ""),
    $(this)
      .parents(".product")
      .find(
        '.product__thumbnail-item[data-variantitem="' + selectVariantId + '"]'
      )
      .addClass("active"),
    $(this)
      .parents(".product")
      .find(
        '.product__thumbnail-item.variant-first_img[data-variantitem="' +
          selectVariantId +
          '"]'
      )
      .attr("aria-current", !0),
    $(this)
      .parents(".product")
      .find(".main-second-image")
      .attr("id", mainImgId + "-2")
      .attr("data-media-id", mainMediaId),
    $(this)
      .parents(".product")
      .find(".main-second-image img")
      .attr("src", mainSecondImg)
      .attr("srcset", mainSecondImg),
    $(this)
      .parents(".product")
      .find(".main-first-image")
      .attr("id", mainImgId)
      .attr("data-media-id", mainMediaId),
    $(this)
      .parents(".product")
      .find(".main-first-image img")
      .attr("src", mainFirstImg)
      .attr("srcset", mainFirstImg);
}),
  $("a").click(function () {
    $("html, body").animate(
      {
        scrollTop: $($(this).attr("href")).offset().top,
      },
      500
    );
    return false;
  });
